import { isString, isDefined } from '@fabric-app/utils/guards/index';
import { useEffect } from 'react';

const useOnClickOutside = (ref, handler, { exceptions = [], priority = false, eventTarget, disabled = false } = {}) => {
  useEffect(
    () => {
      if (disabled) return;
      const listener = (event2) => {
        if (!(event2 instanceof MouseEvent) && !(event2 instanceof TouchEvent)) {
          return;
        }
        const targetRef = ref instanceof HTMLElement || ref === null ? {
          current: ref
        } : ref;
        const target2 = event2.composedPath()[0];
        if (!targetRef.current || targetRef.current.contains(target2)) {
          return;
        }
        if (isDefined(exceptions) && exceptions.length > 0) {
          for (const exception of exceptions) {
            const exceptionElement = exception instanceof HTMLElement ? exception : exception.current;
            if (exceptionElement?.contains(target2)) {
              return;
            }
          }
        }
        handler(event2);
      };
      const target = eventTarget ?? window;
      const event = isString(priority) ? priority : priority ? "mousedown" : "click";
      target.addEventListener(event, listener);
      return () => {
        target.removeEventListener(event, listener);
      };
    },
    // Add ref and handler to effect dependencies
    // It's worth noting that because passed in handler is a new ...
    // ... function on every render that will cause this effect ...
    // ... callback/cleanup to run every render. It's not a big deal ...
    // ... but to optimize you can wrap handler in useCallback before ...
    // ... passing it into this hook.
    [
      ref,
      handler,
      exceptions,
      priority,
      eventTarget,
      disabled
    ]
  );
};

export { useOnClickOutside };
//# sourceMappingURL=useOnClickOutside.js.map
